'use client';

import { Typography } from '@musinsa/mds';
import { useCallback } from 'react';
import { SnackbarActionButton } from './SnackbarAction';
import type { SnackbarProps } from './types';

interface SnackbarComponentProps extends SnackbarProps {
  onClose: () => void;
}

export function Snackbar({ title, message, onClick, onClose, action }: SnackbarComponentProps) {
  const handleClick = useCallback(() => {
    if (!onClick) return;
    onClick();
  }, [onClick]);

  return (
    <div
      className="flex rounded-md bg-gray-700 shadow-md transition-all duration-300"
      style={{
        borderRadius: '4px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        transition: 'all 0.3s ease-out',
        pointerEvents: onClick ? 'auto' : undefined,
      }}
      onClick={handleClick}
      onMouseEnter={(e) => {
        if (onClick) {
          e.currentTarget.style.backgroundColor = '#333333';
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = '#2a2a2a';
      }}
    >
      <div style={{ padding: '9px 12px' }} className="flex flex-1 items-center">
        <div className="flex flex-col flex-1 min-w-0">
          {title && (
            <Typography variant="body13pxMed" colorScheme="white">
              {title}
            </Typography>
          )}
          <Typography
            variant="body13pxReg"
            className="overflow-hidden line-clamp-2"
            colorScheme="white"
          >
            {message}
          </Typography>
        </div>
      </div>
      {action && <SnackbarActionButton action={action} />}
    </div>
  );
}
